// Native companion-app distribution links, used by the token-qualify landing
// (the per-team "does qualifying AND get-the-app" flow) and the admin QR cards.
//
//  • ANDROID_APK_URL — the EAS PRODUCTION APK (runtime 1.0.3, channel
//    "production", version code 7 — the PUSH-enabled build eb871cd1). MUST be a
//    production-channel build so the installed app receives our production OTAs;
//    a "preview"-channel APK never does (that mismatch left Android stuck on an
//    old bundle). Update this string whenever a new production Android APK is built.
//  • IOS_APP_STORE_URL — the public App Store link. Empty until the submitted
//    build clears Apple review; while empty, the landing falls back to iPhone
//    "Add to Home Screen" (PWA) instead of a broken store link.
export const ANDROID_APK_URL = 'https://expo.dev/artifacts/eas/3tPzaQpU3IbzPNvws4P58b8AEg_vq5nFgcb1AyiZqvc.apk'
export const IOS_APP_STORE_URL = 'https://apps.apple.com/app/id6791256098' // v1.0.1 approved + live on the App Store 2026-07-17

// Best "get the native app" target for the CURRENT device, or null when there's
// nothing to offer (desktop/unknown, or the app is already installed / running
// inside the native webview). One source of truth for every get-app CTA so the
// iPhone vs Android split can't drift between screens.
export function getAppTarget() {
  if (typeof window === 'undefined') return null
  const nav = window.navigator || {}
  const ua = nav.userAgent || ''
  // Already have it: installed PWA (iOS `standalone` / Android display-mode) or
  // inside the native app's react-native-webview → don't nag to "get the app".
  const standalone =
    (typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches) ||
    nav.standalone === true
  if (standalone || window.ReactNativeWebView) return null
  // iPhone/iPod, and iPad — iPadOS 13+ reports a desktop "Macintosh" UA, so a
  // touch-capable Mac is treated as iOS too.
  const isIOS =
    /iphone|ipad|ipod/i.test(ua) ||
    (/Macintosh/i.test(ua) && typeof document !== 'undefined' && 'ontouchend' in document)
  const isAndroid = /android/i.test(ua)
  if (isIOS && IOS_APP_STORE_URL) return { platform: 'ios', href: IOS_APP_STORE_URL, label: 'Get it on the App Store' }
  if (isAndroid && ANDROID_APK_URL) return { platform: 'android', href: ANDROID_APK_URL, label: 'Get the Android app' }
  return null
}
